import { Component, EventEmitter, Input, Output } from '@angular/core'

import { CommonModule } from '@angular/common'
import { TranslatePipe } from '@ngx-translate/core'
import { TableModule } from 'primeng/table'
import { TooltipModule } from 'primeng/tooltip'
import { ActionsMenuComponent } from '../actions-menu/actions-menu.component'

@Component({
  selector: 'app-list',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    TableModule,
    TooltipModule,
    ActionsMenuComponent
  ],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss'
})
export class ListComponent {
  @Input() columns: { id: string; name: string }[] = []
  @Input() data: any[] = []
  @Input() totalCount: number = 0
  @Input() currentPage: number = 1
  @Input() itemsPerPage: number = 10
  @Input() sortBy: string = ''
  @Input() descSort: boolean = false
  @Input() actions: any[] = []
  @Input() currentLanguage!: any

  @Output() sortChange = new EventEmitter<string>()
  @Output() pageChange = new EventEmitter<number>()
  @Output() rowClick = new EventEmitter<any>()
  @Output() actionClick = new EventEmitter<any>()

  onSort(colId: string) {
    this.sortChange.emit(colId)
  }

  onPageChange(event: any) {
    this.pageChange.emit(event.page + 1)
  }

  onRowClick(row: any) {
    this.rowClick.emit(row)
  }

  onAction(row: any) {
    this.actionClick.emit(row)
  }

  resolvePath(obj: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj)
  }
}
